// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__aBnOW","gfeWrapper":"CalendarEvent_gfeWrapper__36Ajo"};